import { getApp } from "firebase/app";
import {
  AppCheck,
  ReCaptchaEnterpriseProvider,
  initializeAppCheck,
} from "firebase/app-check";

declare global {
  // eslint-disable-next-line no-var
  var FIREBASE_APPCHECK_DEBUG_TOKEN: boolean | string | undefined;
}

let appCheck: AppCheck | null = null;

/**
 * Starts App Check, which attaches an attestation token to the calls made with
 * the Firebase SDKs. Only the Allaria Fondos spreadsheet function needs it, so
 * it is initialized from that screen instead of on app start: that way the
 * other onboardings do not load reCAPTCHA nor spend assessments.
 *
 * Without VITE_APPCHECK_RECAPTCHA_KEY it does nothing, so any environment
 * where the key is not configured keeps working as before.
 */
export const initAppCheck = () => {
  if (appCheck) return appCheck;

  const siteKey = import.meta.env.VITE_APPCHECK_RECAPTCHA_KEY;
  if (!siteKey) return null;

  // Prints a debug token in the console to register in the Firebase console.
  // It has to be set before initializing App Check.
  if (import.meta.env.VITE_APPCHECK_DEBUG === "true") {
    self.FIREBASE_APPCHECK_DEBUG_TOKEN = true;
  }

  try {
    appCheck = initializeAppCheck(getApp(), {
      provider: new ReCaptchaEnterpriseProvider(siteKey),
      isTokenAutoRefreshEnabled: true,
    });
  } catch (error) {
    // Never block the flow: while the function does not enforce App Check, a
    // request without a token still goes through
    console.log(error, "Error on initAppCheck");
  }

  return appCheck;
};
